import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../Button';
import { IconDateAdd } from '../Icons';
import SessionsTab from './SessionsTab';
import SessionsTabs from './SessionsTabs';

const Sessions = ({ children, onCreate, filter, onFilterChanged, className }) => {
  const { t } = useTranslation('components');
  const cn = useClassNames(() => [className], [className]);

  return (
    <div data-component="Sessions" className={cn}>
      <header className="flex mb-4">
        <SessionsTabs onChange={onFilterChanged}>
          <SessionsTab value="future" selected={filter === 'future'}>
            {t('Sessions.filter.future')}
          </SessionsTab>
          <SessionsTab value="past" selected={filter === 'past'}>
            {t('Sessions.filter.past')}
          </SessionsTab>
        </SessionsTabs>
        <div className="flex-grow" />
        <div>
          <Button onClick={onCreate} kind="primary" className="hidden lg:inline-flex">
            {t('Sessions.createSession')}
          </Button>
          <IconDateAdd onClick={onCreate} size="6" className="lg:hidden text-blue-500 mr-2" />
        </div>
      </header>
      <div hidden={!children}>{children}</div>
    </div>
  );
};

Sessions.propTypes = {
  children: PropTypes.node,
  onCreate: PropTypes.func,
  onFilterChanged: PropTypes.func,
  filter: PropTypes.oneOf(['future', 'past']),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

Sessions.defaultProps = {
  onCreate: () => {},
  onFilterChanged: () => {},
  filter: 'future',
};

export default Sessions;
